// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-wrap {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
}

.onboarding-card {
  width: min(860px, 100%);
  background: #ffffff;
  border-radius: 20px;
  padding: 28px 32px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);
  border: 1px solid #e7edf5;
  display: grid;
  grid-gap: 20px;
  gap: 20px;
}

.onboarding-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.onboarding-title {
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
}

.onboarding-subtitle {
  color: #64748b;
  margin-top: 6px;
}

.onboarding-cancel {
  border: 1px solid #f2c9c9;
  background: #fff2f2;
  color: #b42318;
  padding: 8px 16px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
}

.onboarding-steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 12px;
  gap: 12px;
}

.onboarding-step {
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 12px;
  background: #f8fafc;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  color: #64748b;
}

.onboarding-step.active {
  background: #eaf2ff;
  border-color: #c5dbff;
  color: #1d4ed8;
}

.onboarding-step.done {
  background: #e7f6ec;
  border-color: #b6e3c6;
  color: #1f7a3f;
}

.onboarding-step__index {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: #ffffff;
  border: 1px solid #cbd5f5;
  font-weight: 800;
}

.onboarding-section h3 {
  margin: 0 0 6px;
  font-size: 18px;
  color: #0f172a;
}

.onboarding-section p {
  margin: 0 0 16px;
  color: #64748b;
}

.onboarding-grid {
  display: grid;
  grid-gap: 16px;
  gap: 16px;
}

.onboarding-basics {
  display: grid;
  grid-gap: 20px;
  gap: 20px;
}

.onboarding-avatar {
  display: grid;
  grid-gap: 12px;
  gap: 12px;
  justify-items: start;
}

.onboarding-avatar img,
.onboarding-avatar__placeholder {
  width: 96px;
  height: 96px;
  border-radius: 18px;
  object-fit: cover;
  border: 2px solid #e2e8f0;
  background: #f1f5f9;
  display: grid;
  place-items: center;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.onboarding-avatar__btn {
  border: 1px solid #c5dbff;
  background: #eaf2ff;
  color: #1d4ed8;
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 999px;
  font-weight: 700;
  cursor: pointer;
  display: grid;
  place-items: center;
}

.onboarding-avatar__icon {
  width: 20px;
  height: 20px;
}

.onboarding-grid label,
.onboarding-list label {
  font-size: 13px;
  color: #64748b;
  font-weight: 700;
}

.onboarding-grid input,
.onboarding-list input {
  width: 100%;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  font-size: 14px;
  outline: none;
}

.onboarding-grid input:focus,
.onboarding-list input:focus {
  border-color: #94b4ff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

.onboarding-list {
  display: grid;
  grid-gap: 12px;
  gap: 12px;
}

.onboarding-list__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-gap: 10px;
  gap: 10px;
}

.onboarding-remove {
  border: 1px solid #f2c9c9;
  background: #fff2f2;
  color: #b42318;
  padding: 8px 12px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
}

.onboarding-add {
  border: 1px solid #c5dbff;
  background: #eaf2ff;
  color: #1d4ed8;
  padding: 8px 12px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  width: fit-content;
}

.onboarding-inbox {
  border: 1px dashed #cbd5f5;
  padding: 16px;
  border-radius: 14px;
  background: #f8fafc;
}

.onboarding-inbox__label {
  font-size: 12px;
  color: #64748b;
  font-weight: 700;
  text-transform: uppercase;
}

.onboarding-inbox__value {
  font-weight: 700;
  color: #0f172a;
  margin-top: 6px;
  word-break: break-all;
}

.onboarding-inbox__hint {
  margin-top: 8px;
  color: #64748b;
  font-size: 13px;
}

.onboarding-checkbox {
  margin-top: 12px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  color: #1e293b;
  font-weight: 600;
}

.onboarding-checkbox input {
  margin-top: 2px;
}

.onboarding-actions {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.onboarding-back,
.onboarding-next {
  border: none;
  border-radius: 12px;
  padding: 10px 18px;
  font-weight: 700;
  cursor: pointer;
}

.onboarding-back {
  background: #f1f5f9;
  color: #1e293b;
}

.onboarding-next {
  background: #1d4ed8;
  color: #fff;
}

.onboarding-next:disabled,
.onboarding-back:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.onboarding-error {
  background: #fff2f2;
  border: 1px solid #f2c9c9;
  color: #b42318;
  padding: 10px 14px;
  border-radius: 12px;
}


@media (min-width: 760px) {
  .onboarding-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .onboarding-basics {
    grid-template-columns: 150px minmax(0, 1fr);
    align-items: start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/OnboardingWizard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,yBAAyB;EACzB,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAS;EAAT,SAAS;EACT,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;;AAGA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,2CAA2C;IAC3C,kBAAkB;EACpB;AACF","sourcesContent":[".onboarding-wrap {\n  min-height: 80vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 16px;\n}\n\n.onboarding-card {\n  width: min(860px, 100%);\n  background: #ffffff;\n  border-radius: 20px;\n  padding: 28px 32px;\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);\n  border: 1px solid #e7edf5;\n  display: grid;\n  gap: 20px;\n}\n\n.onboarding-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.onboarding-title {\n  font-size: 24px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.onboarding-subtitle {\n  color: #64748b;\n  margin-top: 6px;\n}\n\n.onboarding-cancel {\n  border: 1px solid #f2c9c9;\n  background: #fff2f2;\n  color: #b42318;\n  padding: 8px 16px;\n  border-radius: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.onboarding-steps {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.onboarding-step {\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 12px;\n  background: #f8fafc;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.onboarding-step.active {\n  background: #eaf2ff;\n  border-color: #c5dbff;\n  color: #1d4ed8;\n}\n\n.onboarding-step.done {\n  background: #e7f6ec;\n  border-color: #b6e3c6;\n  color: #1f7a3f;\n}\n\n.onboarding-step__index {\n  width: 30px;\n  height: 30px;\n  border-radius: 999px;\n  display: grid;\n  place-items: center;\n  background: #ffffff;\n  border: 1px solid #cbd5f5;\n  font-weight: 800;\n}\n\n.onboarding-section h3 {\n  margin: 0 0 6px;\n  font-size: 18px;\n  color: #0f172a;\n}\n\n.onboarding-section p {\n  margin: 0 0 16px;\n  color: #64748b;\n}\n\n.onboarding-grid {\n  display: grid;\n  gap: 16px;\n}\n\n.onboarding-basics {\n  display: grid;\n  gap: 20px;\n}\n\n.onboarding-avatar {\n  display: grid;\n  gap: 12px;\n  justify-items: start;\n}\n\n.onboarding-avatar img,\n.onboarding-avatar__placeholder {\n  width: 96px;\n  height: 96px;\n  border-radius: 18px;\n  object-fit: cover;\n  border: 2px solid #e2e8f0;\n  background: #f1f5f9;\n  display: grid;\n  place-items: center;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.onboarding-avatar__btn {\n  border: 1px solid #c5dbff;\n  background: #eaf2ff;\n  color: #1d4ed8;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border-radius: 999px;\n  font-weight: 700;\n  cursor: pointer;\n  display: grid;\n  place-items: center;\n}\n\n.onboarding-avatar__icon {\n  width: 20px;\n  height: 20px;\n}\n\n.onboarding-grid label,\n.onboarding-list label {\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 700;\n}\n\n.onboarding-grid input,\n.onboarding-list input {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  font-size: 14px;\n  outline: none;\n}\n\n.onboarding-grid input:focus,\n.onboarding-list input:focus {\n  border-color: #94b4ff;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n.onboarding-list {\n  display: grid;\n  gap: 12px;\n}\n\n.onboarding-list__row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 10px;\n}\n\n.onboarding-remove {\n  border: 1px solid #f2c9c9;\n  background: #fff2f2;\n  color: #b42318;\n  padding: 8px 12px;\n  border-radius: 10px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.onboarding-add {\n  border: 1px solid #c5dbff;\n  background: #eaf2ff;\n  color: #1d4ed8;\n  padding: 8px 12px;\n  border-radius: 10px;\n  font-weight: 700;\n  cursor: pointer;\n  width: fit-content;\n}\n\n.onboarding-inbox {\n  border: 1px dashed #cbd5f5;\n  padding: 16px;\n  border-radius: 14px;\n  background: #f8fafc;\n}\n\n.onboarding-inbox__label {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.onboarding-inbox__value {\n  font-weight: 700;\n  color: #0f172a;\n  margin-top: 6px;\n  word-break: break-all;\n}\n\n.onboarding-inbox__hint {\n  margin-top: 8px;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.onboarding-checkbox {\n  margin-top: 12px;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 13px;\n  color: #1e293b;\n  font-weight: 600;\n}\n\n.onboarding-checkbox input {\n  margin-top: 2px;\n}\n\n.onboarding-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.onboarding-back,\n.onboarding-next {\n  border: none;\n  border-radius: 12px;\n  padding: 10px 18px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.onboarding-back {\n  background: #f1f5f9;\n  color: #1e293b;\n}\n\n.onboarding-next {\n  background: #1d4ed8;\n  color: #fff;\n}\n\n.onboarding-next:disabled,\n.onboarding-back:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.onboarding-error {\n  background: #fff2f2;\n  border: 1px solid #f2c9c9;\n  color: #b42318;\n  padding: 10px 14px;\n  border-radius: 12px;\n}\n\n\n@media (min-width: 760px) {\n  .onboarding-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .onboarding-basics {\n    grid-template-columns: 150px minmax(0, 1fr);\n    align-items: start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
